import gql from 'graphql-tag'
import client from '@stores/apollo'
import { INeighborhood } from '@api/types'

interface Payload {
  data: {
    viewer: {
      company: {
        neighborhoods: INeighborhood[]
      }
    }
  }
}

export default function neighborhoodList() {
  return client.gql.query({ query: getAllNeighborhoodsQuery }).then(
    ({
      data: {
        viewer: {
          company: { neighborhoods },
        },
      },
    }: Payload) => neighborhoods
  )
}

export const getAllNeighborhoodsQuery = gql`
  query allNeighborhoods {
    viewer {
      company {
        id
        name
        neighborhoods {
          id
          name
          floor {
            id
          }
        }
      }
    }
  }
`
